import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SelectedButtonState {
  value: string;
}

const initialState: SelectedButtonState = {
  value: 'Impressions', // Default value
};

const selectedButtonSlice = createSlice({
  name: 'selectedButton',
  initialState,
  reducers: {
    setSelectedButton: (state, action: PayloadAction<string>) => {
      state.value = action.payload;
    },
  },
});

export const { setSelectedButton } = selectedButtonSlice.actions;
export default selectedButtonSlice.reducer;
